export const API_BASE_URL = 'https://wallet-server-9d017bbcb7e6.herokuapp.com';
export const TEST_USER = { email: 'guest@gmail.com', password: 'f8kd8ddld9dd' };
